// File: client/src/variants/randomizer/index.js
// Randomizer Chess as a platform plugin.

import rulebook from './rulebook';
import { useRandomizerRuntime } from './useRandomizerRuntime';

const randomizerVariant = {
  id: 'randomizer',
  name: 'Randomizer Chess',
  tagline: 'Chaos strikes every few turns — a random event reshapes the board.',
  icon: '🎲',
  accent: 'from-purple-600 to-indigo-800',
  supportedGameTypes: ['ai', 'local'],
  order: 4,
  rulebook,
  useRuntime: useRandomizerRuntime,
};

export default randomizerVariant;
